<div>
  <p class="authentication__right__card_title">
    {{ 'LOGIN.AUTH.PASSWORD.TITLE' | translate : { username: lookupResult && lookupResult.name | firstName } }}
  </p>

  <div class="authentication__right__card__field" fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="8px">
    <label class="authentication__right__card__field-label"> {{ 'LOGIN.AUTH.PASSWORD.INPUT' | translate }} </label>
    <div class="authentication__right__card__field__input-box">
      <input
        class="authentication__right__card__field__input-box_input"
        [type]="showPassword ? 'text' : 'password'"
        autocomplete="current-password"
        aria-describedby="password-constraints"
        [formControl]="loginForm.controls['password']"
        [placeholder]="'LOGIN.AUTH.PLACEHOLDER' | translate"
      />
      <button
        class="authentication__right__card__field__input-box_suffix"
        mat-icon-button
        type="button"
        (click)="showPassword = !showPassword"
        [matTooltip]="(showPassword ? 'LOGIN.AUTH.PASSWORD.HIDE' : 'LOGIN.AUTH.PASSWORD.SHOW') | translate"
        [matTooltipPosition]="'below'"
      >
        <mat-icon> {{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
    </div>
    <div
      *ngIf="!loginForm.get('password').pristine && loginForm.get('password').touched && loginForm.get('password').invalid"
    >
      <small class="authentication__right__card__field-error" *ngIf="loginForm.get('password').hasError('required')">
        {{ 'LOGIN.AUTH.ERRORS.REQUIRED_PASSWORD' | translate }}
      </small>

      <small class="authentication__right__card__field-error" *ngIf="loginForm.get('password').hasError('failed')">
        {{ 'LOGIN.AUTH.ERRORS.FAILED' | translate }}
      </small>

      <small class="authentication__right__card__field-error" *ngIf="loginForm.get('password').hasError('disabled')">
        {{ 'LOGIN.AUTH.ERRORS.DISABLED' | translate }}
      </small>

      <small
        class="authentication__right__card__field-error"
        *ngIf="loginForm.get('password').hasError('temporaryPasswordExpired')"
      >
        {{ 'LOGIN.AUTH.ERRORS.TEMPORARY_PASSWORD_EXPIRED' | translate }}
      </small>

      <small
        class="authentication__right__card__field-error"
        *ngIf="loginForm.get('password').hasError('passwordAttemptsExceeded')"
      >
        {{ 'LOGIN.AUTH.ERRORS.PASSWORD_ATTEMPTS_EXCEEDED' | translate }}
      </small>

      <small
        class="authentication__right__card__field-error"
        *ngIf="loginForm.get('password').hasError('passwordResetRequired')"
      >
        {{ 'LOGIN.AUTH.ERRORS.PASSWORD_RESET_REQUIRED' | translate }}
      </small>

      <small
        class="authentication__right__card__field-error"
        *ngIf="loginForm.get('password').hasError('unauthorized')"
      >
        {{ 'LOGIN.AUTH.ERRORS.UNAUTHORIZED' | translate }}
      </small>

      <small class="authentication__right__card__field-error" *ngIf="loginForm.get('password').hasError('unknown')">
        {{ 'LOGIN.AUTH.ERRORS.UNKNOWN' | translate }}
      </small>
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="end center">
    <a
      class="authentication__right__card_link"
      [routerLink]="['/login/recuperar-senha']"
      [queryParams]="{ email: loginForm.get('email').value }"
    >
      {{ 'LOGIN.AUTH.FORGOT_PASSWORD' | translate }}
    </a>
  </div>

  <button
    class="authentication__right__card_next"
    data-cy="next-to-auth"
    mat-raised-button
    (click)="authenticate.next()"
    [disabled]="loginForm.invalid || isLoading"
  >
    {{ 'LOGIN.AUTH.NEXT' | translate }}
  </button>

  <div class="authentication__right__card__divisor" fxLayout="row" fxLayoutAlign="stretch center">
    <div class="authentication__right__card__divisor-border"></div>
    <p class="authentication__right__card__divisor-text">{{ 'LOGIN.AUTH.OR' | translate }}</p>
  </div>

  <button
    class="authentication__right__card_next authentication__right__card_next--white mb-22"
    mat-raised-button
    [disabled]="isLoading"
    (click)="authWithGoogle.next()"
  >
    <p fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
      <img src="assets/images/icons/ic_google.svg" alt="Google" />
      <span>{{ 'LOGIN.AUTH.AUTH_WITH_GOOGLE' | translate }}</span>
    </p>
  </button>

  <button
    class="authentication__right__card_next authentication__right__card_next--white mb-22"
    mat-raised-button
    *ngIf="loginCustomization?.clientId && loginCustomization?.tenantId"
    [disabled]="isLoading"
    (click)="authWithAd.next()"
  >
    <p fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
      <img src="assets/images/icons/ic_microsoft.svg" alt="Microsoft" />
      <span>{{ 'LOGIN.AUTH.AUTH_WITH_MICROSOFT' | translate }}</span>
    </p>
  </button>

  <button
    class="authentication__right__card_next authentication__right__card_next--white"
    mat-raised-button
    (click)="returnToEmailStep.next()"
    [disabled]="isLoading"
  >
    {{ 'LOGIN.AUTH.CHANGE_ACCOUNT' | translate }}
  </button>
</div>
